import { View } from 'react-native'
import { useTranslation } from 'react-i18next'
import ModalWide from '@ui/components/Modal/variants/ModalWide'
import Markdown from '@ui/typography/Markdown'

const tNamespace = 'measurement:app.instructions'

type MeasurementType = 'pd' | 'sh'

type ContentProps = {
  measurement: MeasurementType
}

const Section = ({ children }: { children: React.ReactNode }) => (
  <View className="rounded-xl border border-black/10 bg-gray-50 p-8">
    {children}
  </View>
)

function Content({ measurement }: ContentProps) {
  const { t } = useTranslation(['measurement'])
  const tl = `${tNamespace}.${measurement}`

  return (
    <View className="w-full gap-8 px-8 pb-12">
      <Section>
        <Markdown
          style={{
            paragraph: { marginTop: 0, marginBottom: 0 },
          }}
        >
          {t(`${tl}.content.intro`)}
        </Markdown>
      </Section>
      <Section>
        <Markdown
          style={{
            paragraph: { marginTop: 0, marginBottom: 0 },
            ordered_list: { marginBottom: 0, gap: 16 },
            bullet_list: { marginTop: 8, marginBottom: 16, gap: 8 },
          }}
        >
          {t(`${tl}.content.list`)}
        </Markdown>
      </Section>
    </View>
  )
}

interface ModalProps extends ContentProps {
  open: boolean
  close: () => void
}

function Modal({ open, close, measurement }: ModalProps) {
  const { t } = useTranslation(['measurement'])

  return (
    <ModalWide
      open={open}
      close={close}
      showClose
      hideBottomSpace
      center
      title={t(`${tNamespace}.header.title`)}
      cardComponentProps={{
        justifyContent: 'flex-end',
      }}
      body={<Content measurement={measurement} />}
    />
  )
}

const Instructions = {
  Modal,
  Content,
}

Instructions.Modal = Modal
Instructions.Content = Content

export default Instructions
